export enum BillOutCustomForm {
  CreateBillout = 'CreateBillout',
  ReceiveBilloutPayment = 'ReceiveBilloutPayment',
}
